import { atom } from "recoil";

export const currentPlayer = atom({ key: 'currentPlayer', default: '' });